import { render, staticRenderFns } from "./TooltipedChip.vue?vue&type=template&id=08017b95"
import script from "./TooltipedChip.vue?vue&type=script&lang=js"
export * from "./TooltipedChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports